export enum EnumPriceType {
  Cotizacion = 1,
  Futuro = 2,
  IndiceCalculado = 3,
  Parametro = 4,
  FormulaBase = 5,
  Formula = 6,
  Promedio = 7,
  Dummy = 8,
  Apuntamiento = 9,
  ParametroPeriodo = 10
}
